import React, { useState, useEffect } from 'react';

const sampleData = [
  { id: 1, type: 'battery', serial: 'BAT001', brand: 'Panasonic', capacity: 100, bmsOrType: 'BMS Model A', coulomb: 'มีสาย', status: 'พร้อมขาย', reserver: '', receivedDate: '2024-01-15', entryDate: '2024-01-15', note: 'สภาพดี' },
  { id: 2, type: 'charger', serial: 'CHR001', brand: 'Delta', capacity: 15, bmsOrType: 'on board', coulomb: '', status: 'ติดจอง', reserver: 'คุณสมชาย', receivedDate: '2024-02-10', entryDate: '2024-02-10', note: 'ชาร์จเร็ว' },
  { id: 3, type: 'battery', serial: 'BAT002', brand: 'Yuasa', capacity: 120, bmsOrType: 'BMS Model B', coulomb: 'ไร้สาย', status: 'พร้อมขาย', reserver: '', receivedDate: '2024-03-05', entryDate: '2024-03-05', note: '' },
  { id: 4, type: 'charger', serial: 'CHR002', brand: 'Meanwell', capacity: 20, bmsOrType: 'off board', coulomb: '', status: 'พร้อมขาย', reserver: '', receivedDate: '2024-01-20', entryDate: '2024-01-20', note: 'มีพัดลม' },
  { id: 5, type: 'battery', serial: 'BAT003', brand: 'GS', capacity: 80, bmsOrType: 'BMS Model C', coulomb: 'มีสาย', status: 'ติดจอง', reserver: 'คุณสมหญิง', receivedDate: '2024-02-28', entryDate: '2024-02-28', note: 'แบตเตอรี่เก่า' },
  // ข้อมูลตัวอย่าง
];

const StockList = () => {
  const [data, setData] = useState(sampleData);
  const [batteryFilters, setBatteryFilters] = useState({
    status: 'all',
    brand: '',
    search: '',
  });
  const [chargerFilters, setChargerFilters] = useState({
    status: 'all',
    brand: '',
    search: '',
  });

  // ฟังก์ชันคำนวณอายุสินค้า (ใช้วันที่แบบ local เพื่อเลี่ยง off-by-one)
  const calculateAge = (receivedDate) => {
    if (!receivedDate) return '-';

    const s = String(receivedDate).trim();
    let y, m, d;

    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
      const [yy, mm, dd] = s.split('-');
      y = Number(yy); m = Number(mm); d = Number(dd);
    } else if (s.includes('T')) {
      const datePart = s.split('T')[0];
      const parts = datePart.split('-');
      if (parts.length === 3) {
        y = Number(parts[0]); m = Number(parts[1]); d = Number(parts[2]);
      }
    }

    if (y === undefined) {
      const dm = s.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/);
      if (dm) {
        d = Number(dm[1]);
        m = Number(dm[2]);
        y = Number(dm[3]);
      }
    }

    if (y === undefined) {
      const dt = new Date(s);
      if (isNaN(dt)) return '-';
      y = dt.getFullYear();
      m = dt.getMonth() + 1;
      d = dt.getDate();
    }

    const receivedLocal = new Date(y, m - 1, d);
    const now = new Date();
    const todayLocal = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const diffDays = Math.floor((todayLocal - receivedLocal) / 86400000);
    const safeDays = diffDays < 0 ? 0 : diffDays;

    if (safeDays < 30) {
      return `${safeDays} วัน`;
    } else if (safeDays < 365) {
      const months = Math.floor(safeDays / 30);
      return `${months} เดือน`;
    } else {
      const years = Math.floor(safeDays / 365);
      const remainingMonths = Math.floor((safeDays % 365) / 30);
      return remainingMonths > 0 ? `${years} ปี ${remainingMonths} เดือน` : `${years} ปี`;
    }
  };

  const handleBatteryFilterChange = (e) => {
    const { name, value } = e.target;
    setBatteryFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleChargerFilterChange = (e) => {
    const { name, value } = e.target;
    setChargerFilters((prev) => ({ ...prev, [name]: value }));
  };

  const batteryData = data.filter((item) => {
    if (item.type !== 'battery') return false;
    if (batteryFilters.status !== 'all' && item.status !== batteryFilters.status) return false;
    if (batteryFilters.brand && !item.brand.toLowerCase().includes(batteryFilters.brand.toLowerCase())) return false;
    if (batteryFilters.search && !item.serial.toLowerCase().includes(batteryFilters.search.toLowerCase())) return false;
    return true;
  });

  const chargerData = data.filter((item) => {
    if (item.type !== 'charger') return false;
    if (chargerFilters.status !== 'all' && item.status !== chargerFilters.status) return false;
    if (chargerFilters.brand && !item.brand.toLowerCase().includes(chargerFilters.brand.toLowerCase())) return false;
    if (chargerFilters.search && !item.serial.toLowerCase().includes(chargerFilters.search.toLowerCase())) return false;
    return true;
  });

  return (
    <div>
      {/* ตารางแบตเตอรี่ */}
      <div className="mb-5">
        <h3>
          <i className="fas fa-battery-full me-2"></i>
          สต๊อกแบตเตอรี่
        </h3>
        <div className="row mb-3">
          <div className="col-md-4">
            <label>สถานะ</label>
            <select className="form-select" name="status" value={batteryFilters.status} onChange={handleBatteryFilterChange}>
              <option value="all">ทั้งหมด</option>
              <option value="พร้อมขาย">พร้อมขาย</option>
              <option value="ติดจอง">ติดจอง</option>
            </select>
          </div>
          <div className="col-md-4">
            <label>ยี่ห้อ</label>
            <input
              type="text"
              className="form-control"
              name="brand"
              placeholder="ค้นหายี่ห้อ..."
              value={batteryFilters.brand}
              onChange={handleBatteryFilterChange}
            />
          </div>
          <div className="col-md-4">
            <label>ค้นหา ซีเรียล</label>
            <input
              type="text"
              className="form-control"
              name="search"
              placeholder="ค้นหา..."
              value={batteryFilters.search}
              onChange={handleBatteryFilterChange}
            />
          </div>
        </div>

        <table className="table table-striped">
          <thead>
            <tr>
              <th>ซีเรียล</th>
              <th>ยี่ห้อ</th>
              <th>ขนาด (Ah)</th>
              <th>BMS</th>
              <th>คูลอมป์</th>
              <th>สถานะ</th>
              <th>วันรับเข้า</th>
              <th>อายุสินค้า</th>
              <th>หมายเหตุ</th>
              {batteryData.some(item => item.status === 'ติดจอง') && <th>ผู้จอง</th>}
            </tr>
          </thead>
          <tbody>
            {batteryData.length === 0 ? (
              <tr>
                <td colSpan={batteryData.some(item => item.status === 'ติดจอง') ? "10" : "9"} className="text-center">ไม่พบข้อมูล</td>
              </tr>
            ) : (
              batteryData.map((item) => (
                <tr key={item.id}>
                  <td>{item.serial}</td>
                  <td>{item.brand}</td>
                  <td>{item.capacity}</td>
                  <td>{item.bmsOrType}</td>
                  <td>{item.coulomb}</td>
                  <td>{item.status}</td>
                  <td>{item.entryDate}</td>
                  <td>{calculateAge(item.receivedDate)}</td>
                  <td>{item.note || '-'}</td>
                  {batteryData.some(item => item.status === 'ติดจอง') && (
                    <td>{item.status === 'ติดจอง' ? item.reserver : '-'}</td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* ตารางชาร์จเจอร์ */}
      <div className="mb-5">
        <h3>
          <i className="fas fa-plug me-2"></i>
          สต๊อกชาร์จเจอร์
        </h3>
        <div className="row mb-3">
          <div className="col-md-4">
            <label>สถานะ</label>
            <select className="form-select" name="status" value={chargerFilters.status} onChange={handleChargerFilterChange}>
              <option value="all">ทั้งหมด</option>
              <option value="พร้อมขาย">พร้อมขาย</option>
              <option value="ติดจอง">ติดจอง</option>
            </select>
          </div>
          <div className="col-md-4">
            <label>ยี่ห้อ</label>
            <input
              type="text"
              className="form-control"
              name="brand"
              placeholder="ค้นหายี่ห้อ..."
              value={chargerFilters.brand}
              onChange={handleChargerFilterChange}
            />
          </div>
          <div className="col-md-4">
            <label>ค้นหา ซีเรียล</label>
            <input
              type="text"
              className="form-control"
              name="search"
              placeholder="ค้นหา..."
              value={chargerFilters.search}
              onChange={handleChargerFilterChange}
            />
          </div>
        </div>

        <table className="table table-striped">
          <thead>
            <tr>
              <th>ซีเรียล</th>
              <th>ยี่ห้อ</th>
              <th>ขนาด (A)</th>
              <th>ประเภท</th>
              <th>สถานะ</th>
              <th>วันรับเข้า</th>
              <th>อายุสินค้า</th>
              <th>หมายเหตุ</th>
              {chargerData.some(item => item.status === 'ติดจอง') && <th>ผู้จอง</th>}
            </tr>
          </thead>
          <tbody>
            {chargerData.length === 0 ? (
              <tr>
                <td colSpan={chargerData.some(item => item.status === 'ติดจอง') ? "9" : "8"} className="text-center">ไม่พบข้อมูล</td>
              </tr>
            ) : (
              chargerData.map((item) => (
                <tr key={item.id}>
                  <td>{item.serial}</td>
                  <td>{item.brand}</td>
                  <td>{item.capacity}</td>
                  <td>{item.bmsOrType}</td>
                  <td>{item.status}</td>
                  <td>{item.entryDate}</td>
                  <td>{calculateAge(item.receivedDate)}</td>
                  <td>{item.note || '-'}</td>
                  {chargerData.some(item => item.status === 'ติดจอง') && (
                    <td>{item.status === 'ติดจอง' ? item.reserver : '-'}</td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StockList;
